export const clientIdGoogleLogin = `${process.env.REACT_APP_CLIENT_ID_GOOGLE_LOGIN}`;
export const appIdFacebookLogin = `${process.env.NEXT_PUBLIC_CLIENT_ID_FACEBOOK_LOGIN}`;

export const ROLES = {
  TEACHER: 'teacher',
  PARENT: 'parent',
  VENDOR: 'vendor',
};
